import { v4 as uuidv4 } from 'uuid';
import BeatInfo from './beat-info';
const beatsInfoData = [
    {
        name: 'Zuckell - Loop 6',
        url: '/beats/zuckell-loop6-short.mp3',
        bars: 2
    },
];
const beatInfoCollection = new Map();
for (const beatInfoData of beatsInfoData) {
    const id = uuidv4();
    const beatInfo = new BeatInfo(id, beatInfoData.name, beatInfoData.url, beatInfoData.bars);
    beatInfoCollection.set(id, beatInfo);
}
const getBeatInfoById = (id) => {
    return beatInfoCollection.get(id);
};
export default beatInfoCollection;
export { beatInfoCollection, BeatInfo, getBeatInfoById, };
